import { ProjectCreate, ProjectResponse } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useInvalidateProjectListQuery } from "@/queries/query-project";

export const useCreateNewProject = () => {
  const invalidateProjectListQuery = useInvalidateProjectListQuery();

  return useMutationWithErrorHandler<ProjectResponse, ApiError, ProjectCreate>(
    async ({ name, code, description, location }) => {
      const project = await getRanaApiV1().ProjectsApi.projectCreate({
        projectCreate: {
          name,
          code,
          description: description ?? "",
          location,
        },
      });

      await invalidateProjectListQuery();

      return project;
    },
    {}
  );
};
